<template>
  <div id="app">
    <template v-if="initialized">
      <router-view/>
    </template>
  </div>
</template>

<script>
export default {
  name: 'App',

  data() {
    return {
      initialized: false
    }
  },

  async mounted() {
    this.initialized = false
    try {
      await this.$store.dispatch('restoreHeaders')
    } finally {
      this.initialized = true
    }
  }
}
</script>
